"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PXWidgetConfig_1 = require("../../../Extendables/PXWidgetConfig");
class ViewWidgetConfig extends PXWidgetConfig_1.default {
    static getValueMapping() {
        const mapping = super.getValueMapping();
        mapping.value.token.required = true;
        return mapping;
    }
}
exports.default = ViewWidgetConfig;
